var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraphqlLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "GraphQL_Logo",
    x: 0,
    y: 0,
    enableBackground: "new 0 0 400 400",
    viewBox: "0 0 400 400",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16.6,
    height: 320.3,
    x: 122,
    y: -0.4,
    fill: "#E535AB",
    transform: "matrix(-0.866 -0.5 0.5 -0.866 163.3196 363.3136)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 320.3,
    height: 16.6,
    x: 39.8,
    y: 272.2,
    fill: "#E535AB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 185,
    height: 16.6,
    x: 37.9,
    y: 312.2,
    fill: "#E535AB",
    transform: "matrix(-0.866 -0.5 0.5 -0.866 83.0693 663.3409)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 185,
    height: 16.6,
    x: 177.1,
    y: 71.1,
    fill: "#E535AB",
    transform: "matrix(-0.866 -0.5 0.5 -0.866 463.3409 283.0693)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 16.6,
    height: 185,
    x: 122.1,
    y: -13,
    fill: "#E535AB",
    transform: "matrix(-0.5 -0.866 0.866 -0.5 126.7903 232.1221)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 320.3,
    height: 16.6,
    x: 109.6,
    y: 151.6,
    fill: "#E535AB",
    transform: "matrix(-0.5 -0.866 0.866 -0.5 266.0828 473.3766)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 16.6,
    height: 185,
    x: 52.5,
    y: 107.5,
    fill: "#E535AB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 16.6,
    height: 185,
    x: 330.9,
    y: 107.5,
    fill: "#E535AB"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 14.5,
    height: 160.9,
    x: 262.4,
    y: 240.1,
    fill: "#E535AB",
    transform: "matrix(-0.5 -0.866 0.866 -0.5 126.7953 714.2875)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E535AB",
    d: "M369.5,297.9c-9.6,16.7-31,22.4-47.7,12.8c-16.7-9.6-22.4-31-12.8-47.7c9.6-16.7,31-22.4,47.7-12.8 C373.5,259.9,379.2,281.2,369.5,297.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E535AB",
    d: "M90.9,137c-9.6,16.7-31,22.4-47.7,12.8c-16.7-9.6-22.4-31-12.8-47.7c9.6-16.7,31-22.4,47.7-12.8 C94.8,99,100.5,120.3,90.9,137"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E535AB",
    d: "M30.5,297.9c-9.6-16.7-3.9-38,12.8-47.7c16.7-9.6,38-3.9,47.7,12.8c9.6,16.7,3.9,38-12.8,47.7 C61.4,320.3,40.1,314.6,30.5,297.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E535AB",
    d: "M309.1,137c-9.6-16.7-3.9-38,12.8-47.7c16.7-9.6,38-3.9,47.7,12.8c9.6,16.7,3.9,38-12.8,47.7 C340.1,159.4,318.7,153.7,309.1,137"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E535AB",
    d: "M200,395.8c-19.3,0-34.9-15.6-34.9-34.9c0-19.3,15.6-34.9,34.9-34.9c19.3,0,34.9,15.6,34.9,34.9 C234.9,380.1,219.3,395.8,200,395.8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#E535AB",
    d: "M200,74c-19.3,0-34.9-15.6-34.9-34.9c0-19.3,15.6-34.9,34.9-34.9c19.3,0,34.9,15.6,34.9,34.9 C234.9,58.4,219.3,74,200,74"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphqlLogo);
export default __webpack_public_path__ + "static/media/Graphql-logo.bd63f9d8b9b4780076cbd22532776935.svg";
export { ForwardRef as ReactComponent };